import { RoutablePage, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';

/**
 * Component displaying list of updated consents to accept with a summary
 * of what has been updated and link to account closure
 */
var TermsUpdatedPromptComponent = /** @class */ (function (_super) {
    __extends(TermsUpdatedPromptComponent, _super);
    function TermsUpdatedPromptComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        return _this;
    }
    Object.defineProperty(TermsUpdatedPromptComponent.prototype, "updatedSummaries", {
        get: function () {
            return this.consents.map(function (_a) {
                var consentContents = _a.consentContents;
                return consentContents.content;
            });
        },
        enumerable: false,
        configurable: true
    });
    TermsUpdatedPromptComponent.prototype.decline = function () {
        if (this.isLoading) {
            return;
        }
        this.routeTo({ route: RoutablePage.ACCOUNT_CLOSURE });
    };
    TermsUpdatedPromptComponent.prototype.agree = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading) {
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, magic.methods.users.saveUserConsents(this.consents.map(function (consent) { return (__assign(__assign({}, consent), { consented: true })); }))];
                    case 2:
                        _a.sent();
                        notificationService.show(this.$t('terms-updated.updated'), {
                            style: NotificationStyle.SUCCESS,
                        });
                        this.closeAndAccept();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        notificationService.show(this.$t('terms-updated.unexpected-error'), {
                            style: NotificationStyle.ERROR,
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TermsUpdatedPromptComponent.prototype.closeAndAccept = function () {
        return;
    };
    __decorate([
        Prop({
            type: Array,
            default: [],
        }),
        __metadata("design:type", Array)
    ], TermsUpdatedPromptComponent.prototype, "consents", void 0);
    __decorate([
        Emit('acceptedTerms'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TermsUpdatedPromptComponent.prototype, "closeAndAccept", null);
    TermsUpdatedPromptComponent = __decorate([
        Component({
            name: 'terms-updated-prompt',
        })
    ], TermsUpdatedPromptComponent);
    return TermsUpdatedPromptComponent;
}(Mixins(MagicConfigMixin)));

export default TermsUpdatedPromptComponent;
